import { InsightsDealActivityStatusEnum } from "@vega-api/generated/types/insightsDealActivityStatusEnum";
import { type LimitedPartnerDealActivity } from "@vega-api/generated/types/limitedPartnerDealActivity";
import { assertNever } from "@vega-core/utils/assertNever";

export type BucketedDeals = {
  committed: LimitedPartnerDealActivity[];
  prospecting: LimitedPartnerDealActivity[];
  passed: LimitedPartnerDealActivity[];
};

// Splits the flat deal list into the three deal-list tabs. Status drives the
// bucket; the backend has already collapsed the underlying opportunity statuses
// into COMMITTED / PROSPECTING / PASSED.
export const bucketDealsByStatus = (
  deals: LimitedPartnerDealActivity[],
): BucketedDeals => {
  const buckets: BucketedDeals = {
    committed: [],
    prospecting: [],
    passed: [],
  };

  for (const deal of deals) {
    switch (deal.status) {
      case InsightsDealActivityStatusEnum.COMMITTED:
        buckets.committed.push(deal);
        break;
      case InsightsDealActivityStatusEnum.PROSPECTING:
        buckets.prospecting.push(deal);
        break;
      case InsightsDealActivityStatusEnum.PASSED:
        buckets.passed.push(deal);
        break;
      default:
        // Fails to compile if the contract enum gains a status, so a new
        // bucket must be handled rather than silently dropped from the tabs.
        assertNever(deal.status, {
          functionName: "bucketDealsByStatus",
        });
    }
  }

  return buckets;
};
